import { Grid } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { UserRole } from '@synergy/models';

import { ContactDetailPermissionsRoleField } from './contact-detail-permissions-role-field';

export const ContactDetailPermissionsRolesSupplier = () => {
    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.contactsAndOrganizations.contact.portal.supplier" />

            <Grid container={true} columnSpacing={2} sx={{ mt: 0 }}>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.Extranet} />
                </Grid>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.SupplierAdmin} />
                </Grid>
            </Grid>
        </>
    );
};
